import React from 'react';
import styled from 'styled-components';
import SalesChampionSection from './SalesChampionSection';
import { cores } from '../../../../styles/styleUtils';

const ChartsContainer = styled.div`
  padding: 20px;
  background-color: ${cores.cinzaClaro};
  display: flex;
  flex-direction: column;
  gap: 30px; // Space between major sections
  font-family: sans-serif; // Basic font
  color: ${cores.chumbo};
`;

const ChartsSection3 = ({ campeaoVendas }) => {
  return (
    <ChartsContainer>
      <SalesChampionSection campeaoVendas={campeaoVendas}/>
    </ChartsContainer>
  );
};

export default ChartsSection3;
